import React from "react";
import "./Tiktokbenefits.css";
import ContactForm from "../Common/ContactForm";

const FlashIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M14 2L5 15H12L11 24L21 10H14L14 2Z"
      fill="white"
      opacity="0.25"
      stroke="white"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

const LinkIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M10 16L16 10M9 11L7 13C5.5 14.5 5.5 17 7 18.5C8.5 20 11 20 12.5 18.5L14.5 16.5M17 11L19 9C20.5 7.5 20.5 5 19 3.5C17.5 2 15 2 13.5 3.5L11.5 5.5"
      stroke="white"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <circle cx="13" cy="13" r="9" stroke="white" strokeWidth="1.4" opacity="0.35" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M13 3L21 7V13C21 18 17.5 21.5 13 23C8.5 21.5 5 18 5 13V7L13 3Z"
      fill="white"
      opacity="0.2"
      stroke="white"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M9.5 13L11.8 15.3L16.5 10.5" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const definitionCards = [
  {
    icon: <FlashIcon />,
    accent: "orange",
    title: "Faster delivery",
    desc: "Fast, reliable shipping helps improve customer satisfaction and supports timely order delivery.",
  },
  {
    icon: <LinkIcon />,
    accent: "blue",
    title: "Streamlined operations",
    desc: "Focus on growing your business while we manage your fulfilment operations from inventory to delivery.",
  },
  {
    icon: <ShieldIcon />,
    accent: "blue",
    title: "Scalable solutions",
    desc: "Scalable TikTok Shop fulfilment UK solutions designed to support brands from launch through international growth.",
  },
];

const handlingNodes = [
  {
    number: "01",
    accent: "orange",
    title: "Live order spikes",
    desc: "Lightning-fast fulfilment built to handle sudden spikes in order demand.",
  },
  {
    number: "02",
    accent: "blue",
    title: "Fast pick & pack",
    desc: "Barcode-driven accuracy ensuring reliable picking, packing, and parcel assembly processes.",
  },
  {
    number: "03",
    accent: "orange",
    title: "Inventory sync",
    desc: "Real-time inventory synchronisation keeps stock levels accurate across all sales channels.",
  },
  {
    number: "04",
    accent: "blue",
    title: "Rapid dispatch",
    desc: "Prime-level fulfilment performance with rapid same-day order processing and dispatch.",
  },
];

const spikeRows = [
  {
    badge: "Instant Sync",
    accent: "blue",
    title: "1. Automated Queue Ingestion",
    desc: "The moment a viewer clicks buy on your TikTok Shop, our Mintsoft WMS bypasses manual spreadsheets. Orders drop directly into our digital packing queue within milliseconds, completely eliminating data entry backlogs.",
  },
  {
    badge: "99.8% Accurate",
    accent: "orange",
    title: "2. Dynamic Batch-Picking & Barcode Validation",
    desc: "To manage speed without losing accuracy, our team utilizes optimized batch-picking paths. Every single SKU is barcode-scanned at the packing station, ensuring that even during a 1,000-order viral surge, the correct items go to the correct buyers.",
  },
  {
    badge: "SLA Safe",
    accent: "blue",
    title: "3. Priority Carrier Handshakes",
    desc: "We have established daily, high-volume collections with the UK's leading parcel networks (Royal Mail, Evri, and DPD) straight from our Milton Keynes hub. Your packages are sorted and injected directly into carrier routes to meet strict TikTok dispatch SLAs.",
  },
];

const TikTokBenefits: React.FC = () => {
  return (
    <section className="ttb-wrapper">
      <div className="ttb-container">
      <div className="ttb-definition">
        <div className="ttb-definition-intro">
          <h2 className="ttb-definition-title">Built for TikTok Shop Growth</h2>
          <p className="ttb-definition-lead">
            Everything needed to fulfil orders faster, operate efficiently, and scale your ecommerce business.
          </p>
        </div>

        <div className="ttb-definition-grid">
          {definitionCards.map((card, i) => (
            <article key={i} className={`ttb-definition-card ttb-definition-card--${card.accent}`}>
              <div className={`ttb-definition-icon ttb-definition-icon--${card.accent}`}>
                {card.icon}
              </div>
              <h3 className="ttb-definition-card-title">{card.title}</h3>
              <p className="ttb-definition-card-desc">{card.desc}</p>
              <div className={`ttb-definition-glow ttb-definition-glow--${card.accent}`} />
              <div className={`ttb-definition-bar ttb-definition-bar--${card.accent}`} />
            </article>
          ))}
        </div>
      </div>

      
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '40px', alignItems: 'start' }} className="tiktok-viral-grid">
          <div className="ttb-handling">
        <div className="ttb-handling-intro">
          <h2 className="ttb-handling-title" style={{ textAlign: "left" }}>Handling Viral Volume</h2>
        </div>

        <div className="ttb-handling-grid">
          <div className="ttb-handling-line" aria-hidden="true" />
          {handlingNodes.map((node, i) => (
            <article
              key={i}
              className={`ttb-handling-node ttb-handling-node--${node.accent}`}
            >
              <div className={`ttb-handling-number ttb-handling-number--${node.accent}`}>
                {node.number}
              </div>
              <div className="ttb-handling-content">
                <h3 className="ttb-handling-node-title">{node.title}</h3>
                <p className="ttb-handling-node-desc">{node.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
          <div style={{ background: '#ffffff', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05)' }}>
            <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '1.5rem', color: '#1a202c', fontWeight: 'bold' }}>Discuss your TikTok Shop Fulfilment</h3>
            <ContactForm source="tiktok-live-sales" />
          </div>
        </div>


      <div className="tiktok-compliance-trust-box">
        <div className="trust-box-header">
          <span className="compliance-icon" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M11 2L20 18H2L11 2Z"
                fill="#F68C44"
                stroke="#e8742a"
                strokeWidth="1.2"
                strokeLinejoin="round"
              />
              <path d="M11 8V12" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
              <circle cx="11" cy="15.5" r="1" fill="white" />
            </svg>
          </span>
          <h3>Official TikTok Shop Compliance Notice</h3>
        </div>

        <div className="trust-box-body">
          <p>
            TikTok live sales can create sudden order spikes, so fulfilment has to stay fast, accurate, and fully
            traceable. TikTok Shop expects sellers to dispatch within required{' '}
            <a href="https://seller-uk.tiktok.com" target="_blank" rel="noopener noreferrer nofollow">
              <strong>SLAs (Service Level Agreements)</strong>
            </a>
            , maintain valid tracking, and keep inventory accurate to avoid late dispatch or cancellation issues.
            That is why our fulfilment process is built around same-day workflow control, barcode accuracy, and
            real-time stock syncing.
          </p>
        </div>
      </div>

      <div className="ttb-spikes">
        <div className="ttb-spikes-intro">
          <h2 className="ttb-spikes-title">How We Handle Viral Order Spikes</h2>
          <p className="ttb-spikes-lead">
            When your TikTok Live stream takes off, our warehouse floor goes into overdrive. We don't panic over
            volume surges; we execute an automated, high-velocity operational workflow engineered to process
            hundreds of viral impulse orders simultaneously.
          </p>
        </div>

        <div className="ttb-spikes-container">
          {spikeRows.map((row, i) => (
            <article key={i} className={`ttb-spike-row ttb-spike-row--${row.accent}`}>
              <div className={`ttb-spike-badge ttb-spike-badge--${row.accent}`}>
                {row.badge}
              </div>
              <div className="ttb-spike-details">
                <h3 className="ttb-spike-details-title">{row.title}</h3>
                <p className="ttb-spike-details-desc">{row.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
};

export default TikTokBenefits;
